// isPastAuctionUnit menentukan apakah unit TIDAK boleh diakses publik. Hanya unit
// yang sudah dialokasikan ke sebuah lelang DAN lelangnya belum selesai yang boleh
// tampil (auction_status ada & bukan CLOSED). Semua kondisi lain diblokir:
// - Tanpa relasi lelang (auction_status null): unit stok murni, tak boleh tampil publik.
// - Lelang sudah selesai (auction_status CLOSED): unit lampau, mis. plat nomor terjual.
// auction_status andal untuk semua kategori lelang:
// - TIME-BID / CLOSE-BID: scheduler men-set status saat waktu selesai lewat.
// - Reguler (konduktor): status CLOSED di-set saat konduktor menutup lelang, sehingga
//   akurat meski selesai aktual molor/lebih cepat dari time_finish terjadwal.
// Dipakai untuk memblokir akses publik + noindex unit yang tidak sedang dilelangkan.
export const isPastAuctionUnit = (unit) =>
  unit?.auction_status == null || unit?.auction_status === "CLOSED";
